import { eachRight, forEach } from "lodash";
import store from "./store";
import axios from "axios";
export const helper = {
    store,
    empty: window.empty,
    trans: window.trans,
    pushSelectedDataLayers: function(pushBefore=7) {
        let thisFunction = this; 
        let selectedOption = thisFunction.store.state.selectedShippingOption;

        for (let currentStep = 1; currentStep < pushBefore; currentStep++) {
            let step = thisFunction.clientAdminStepFromActualStep(currentStep);
            let stringStep = thisFunction.stepToString(step);

            if(!thisFunction.store.state.checkOutSteps[stringStep]) {            
                thisFunction.pushDataLayer(step, selectedOption);  
                thisFunction.store.state.checkOutSteps[stringStep] = true;  
            }             
        }                 
    },
    validate: async function(types, validationFields, type='simple', validateAllFields = false) {
        let thisFunction = this;
        let data = {
            validationsTypes: types,
            ...validationFields
        };     

        let multiErrorKeys = [/^packages.\d{0,}$/i];

        let openedAccordion = false;
        let valid = false;
        await axios.post(thisFunction.store.state.$routes['api.fields_validator'], data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(response){
            $('#toast_container').find('.custom-toast').remove();
            $('.ups-danger-text').remove();
            $('.alert-danger-ups').removeClass('alert-danger-ups');
            $('.custom-ups-error-parent').removeClass('custom-ups-error-parent');
            valid = true;     
   
        }).catch(function(error){
            if (error.response !== undefined && error.response.status === 422) {
                let invoiceModalInvalid = false; 
                $('.ups-danger-text').remove();
                $('.alert-danger-ups').removeClass('alert-danger-ups');
                $('.custom-ups-error-parent').removeClass('custom-ups-error-parent');

                let exceptClasses = [
                    '.otherDeliveryInformation_voecVatRegistration_input', 
                    '.otherDeliveryInformation_pvaRegistration_input', 
                    '.notifications_senderEmail_input',
                    '.notifications_receiverEmail_input',
                    '.notifications_otherEmail_input',
                ]; 
                
                if (thisFunction.store.state.selectedFormType === 'mass') {                
                    thisFunction.openedAccordionById('mass-shipments-parent', 0, true);
                }

                $('#toast_container').find('.custom-toast').remove();
                $.each(error.response.data.errors, function (errorKey, errors) {
                    if (errorKey == 'shippingOptionCode' && !thisFunction.store.state.inClientAdmin) {
                        thisFunction.store.state.calculatorState = 'senderServiceSelector';
                        thisFunction.store.state.selectShippingOption = true;
                    }

                    let inputName = `.${errorKey.replaceAll('.', '_')}_input`;
                    if (errorKey.replaceAll('.', '_').search('commercialInvoiceModal') !== -1) {
                        invoiceModalInvalid = true;
                    }

                    let isMultiError = false;
                    $.each(multiErrorKeys, (index, element) => {
                        if(element.test(errorKey)){
                            isMultiError = true;
                        }
                    });
           
                    let input = $(inputName);
                    
                    if (input.length > 0) {
                        if (thisFunction.store.state.selectedFormType === 'mass') {
                            $(inputName).parent().parent().parent().parent().parent().find('.shipment-details-header').addClass('alert-danger-ups');
                        }
                 
                        if (!openedAccordion){                           
                            let accordion_id = $(inputName).parents('.accordion').first().attr('id');                            
                            
                            if (accordion_id === undefined) {
                                accordion_id = $(inputName).parents('.accordion').first().find('div').first().attr('id');   
                            }

                            let failedLevel = thisFunction.getLevelIdByAccordion(accordion_id);
                           
                            if (validateAllFields) {
                                let accordion = undefined;
                                for (let index = failedLevel -1; index < failedLevel; index++) {
                                    accordion = $('.accordion').eq(index).attr('id'); 

                                    if (accordion === undefined) {
                                        accordion = $('.accordion').eq(index).find('div').first().attr('id');   
                                    }       
                                                
                                    thisFunction.openedAccordionById(accordion, 0, true);
                                }
                            }

                            if (type == 'continue') {                       
                                thisFunction.pushSelectedDataLayers(failedLevel);
                            }

                            thisFunction.store.state.currentLevel = failedLevel;
                            thisFunction.store.state.shippingTabLevel = failedLevel;
                        
                            thisFunction.openedAccordionById(accordion_id, 0, false);
                            openedAccordion = true;
                        }

                        if (!isMultiError) {
                            errors = [errors[0]];
                        }
                          
                        if (!$(inputName).hasClass('main_div') && !exceptClasses.includes(inputName)) {
                            $(inputName).addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent');  
                        }                      

                        $.each(errors, (index, errorText) => {                           
                            if ($(inputName).hasClass('main_div')) {
                                $(inputName).append(`<span class="ups-danger-text ml-3">${errorText}</span>`);
                            } else {                                    
                                $(inputName).parent().append(`<span class="ups-danger-text ml-3">${errorText}</span>`);
                            }
                        });

                    } else {
                        if(!isMultiError){
                            errors = [errors[0]];
                        }

                        if (!thisFunction.store.state.selectShippingOption) {
                            $.each(errors, (index, errorText) => {
                                showToast(errorText, "#c91a13", 30000);
                            });
                        }
                    }

                    if (thisFunction.store.state.$siteSettings['debug']) {
                        console.log(inputName);
                    }
                });
                
                if (invoiceModalInvalid) {
                    $('.commercialInvoiceModal_radio_input').addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent').append(`<span class="ups-danger-text ml-3">Komercinėje sąskaitoje yra klaidų</span>`);
                }                
            }
        });

        if (type == 'continue' && valid) {
            thisFunction.pushSelectedDataLayers();
        }

        return valid;
    },
    toggleAccordion: async function(newLevel, needsValidation=false, noActualChange=false, scrollToOffset=0){ 
        if((newLevel === 5 && this.store.state.selectedFormType !== 'mass') && this.store.state.shippingTabLevel < newLevel-1){
            return;
        } 
        
        if (this.store.state.currentLevel === undefined) {
            this.store.state.currentLevel = newLevel-1;
        }
        
        if(this.store.state.currentLevel > newLevel){
            needsValidation = false;
        }
   
        let valid = true;

        if (this.store.state.selectedFormType === 'mass' && this.store.state.currentLevel === 2 && !store.state.needCommercialInvoice) {
            needsValidation = false;
            if (!noActualChange) {
                newLevel = 6;
            }
            this.store.state.currentLevel = 3;
        }      

        if (this.store.state.copied && this.store.state.currentLevel > 4) {
            if (!this.store.state.selectedShippingOption.serviceCode) {    
                this.store.state.selectShippingService = true;       
                let option = this.store.state.selectedShippingOption.serviceCode || '';
                valid = await this.validate(['shippingOptionCode'],  {
                    shippingOptionCode: option.toString(),
                });                                            
                return;
            }
        }

        if(needsValidation){             
            switch(this.store.state.currentLevel){
                case 1:
                    valid = await this.validate(['shipperAddressInformation', 'countriesFrom'], {
                        shipperAddressInformation: this.store.state.shipperAddressInformation,
                        from: {
                            ...this.store.state.from,
                            city: this.store.state.shipperAddressInformation.city,
                        },
                    });
                    break;
                case 2:
                    if (this.store.state.selectedFormType === 'single') {
                        valid = await this.validate(['deliveryAddressInformation', 'countriesTo'], {
                            deliveryAddressInformation: this.store.state.deliveryAddressInformation,
                            to: {
                                ...this.store.state.to,
                                city: this.store.state.deliveryAddressInformation.city,
                                postCode: this.store.state.to.postCode,
                            },
                            from: {
                                ...this.store.state.from,
                                city: this.store.state.shipperAddressInformation.city, 
                                postCode: this.store.state.from.postCode,                           
                            },
                        });
                    } else {
                        let checkAllShipmentsHasServices = true;
                        $.each(this.store.state.massShipments, function (index, element) {                            
                            if (!element.service.serviceCode) {
                                checkAllShipmentsHasServices = false;
                                return;
                            }
                        });
                        if (!checkAllShipmentsHasServices) {    
                            this.store.state.selectShippingService = false;                                             
                            return;
                        }

                        valid = await this.validate(['massShipments', 'countriesFrom'], {
                            massShipments: this.store.state.massShipments,   
                            selectedFormType: this.store.state.selectedFormType,                   
                            from: {
                                ...this.store.state.from,
                                city: this.store.state.shipperAddressInformation.city, 
                                postCode: this.store.state.from.postCode,                           
                            },
                        });
                    }
                    break;
                case 3: 
                    if(this.store.state.inClientAdmin) {
                        valid = await this.validate(['packages'],  {
                            packageType: this.store.state.packageType,
                            packages: this.store.state.packagesDimensions,
                        });
                    } else {
                        let option = this.store.state.selectedShippingOption.serviceCode || '';
                        valid = await this.validate(['otherDeliveryInformation', 'commercialInvoice', 'commercialInvoiceModal', 'packagesInsurance', 'notifications'],  {
                            otherDeliveryInformation: this.store.state.otherDeliveryInformation,
                            uploadedFiles: this.store.state.uploadedFiles,
                            commercialInvoiceModal: this.store.state.commercialInvoiceModal,
                            commercialInvoice: {
                                invoiceTotal: this.store.state.otherDeliveryInformation.invoiceTotal,
                                invoiceCurrency: this.store.state.otherDeliveryInformation.invoiceCurrency,
                            },
                            packages: this.store.state.packagesDimensions,
                            to: this.store.state.to,
                            from: this.store.state.from,
                            shippingOptionCode: option.toString(),
                            packageType: this.store.state.packageType,
                            notifications: {
                                senderEmail: this.store.state.shipperAddressInformation.email,
                                receiverEmail: this.store.state.deliveryAddressInformation.email,
                                otherEmail: this.store.state.otherDeliveryInformation.otherNotificationsEmail,
                            },
                        });
                    }
                    break;
                case 4:
                    if(this.store.state.inClientAdmin) {
                        if(newLevel >= 4){
                            if(!this.store.state.selectedShippingOption.serviceCode){    
                                this.store.state.selectShippingService = false;                                             
                                return;
                            }
                            this.store.state.selectShippingService = true;       
                            let option = this.store.state.selectedShippingOption.serviceCode || '';
                            valid = await this.validate(['shippingOptionCode'],  {
                                shippingOptionCode: option.toString(),
                            });
                        }
                    } else{
                        valid = await this.validate(['carrierInfo', 'differentAddressInfo', 'importInformation'],  {
                            carrierInfo: this.store.state.carrierInfo,
                            selectedShippingOption:{
                                estimatedPickup: this.store.state.selectedShippingOption.estimatedPickup,
                            },
                            from: {
                                country: this.store.state.from.country,
                                postCode: this.store.state.from.postCode,
                            },
                            importInformation: this.store.state.importInformation,
                        });
                    }
                    break;    
                case 5:            
                    if(this.store.state.inClientAdmin){
                        if (this.store.state.selectedFormType === 'single') {
                            let option = this.store.state.selectedShippingOption.serviceCode || '';
                            valid = await this.validate(['otherDeliveryInformation', 'commercialInvoice', 'commercialInvoiceModal', 'packagesInsurance', 'notifications'],  {
                                otherDeliveryInformation: this.store.state.otherDeliveryInformation,
                                uploadedFiles: this.store.state.uploadedFiles,
                                commercialInvoiceModal: this.store.state.commercialInvoiceModal,
                                commercialInvoice: {
                                    invoiceTotal: this.store.state.otherDeliveryInformation.invoiceTotal,
                                    invoiceCurrency: this.store.state.otherDeliveryInformation.invoiceCurrency,
                                },
                                packages: this.store.state.packagesDimensions,
                                to: this.store.state.to,
                                from: this.store.state.from,
                                shippingOptionCode: option.toString(),
                                packageType: this.store.state.packageType,
                                notifications: {
                                    senderEmail: this.store.state.shipperAddressInformation.email,
                                    receiverEmail: this.store.state.deliveryAddressInformation.email,
                                    otherEmail: this.store.state.otherDeliveryInformation.otherNotificationsEmail,
                                }
                            });
                        } else {
                            valid = await this.validate([
                                'commercialInvoice', 'commercialInvoiceModal', 'massShipmentsCommercialInvoice'
                            ], {                     
                                selectedFormType: this.store.state.selectedFormType,
                                massShipments: this.store.state.massShipments,          
                                from: this.store.state.from,                             
                            });
                        } 
                    } else{                        
                        valid = await this.validate(['differentPaymentInformation', 'majorPaymentType'],  {
                            differentPaymentInformation: this.store.state.differentPaymentInformation,
                            majorPaymentType: this.store.state.majorPaymentType,
                            from: this.store.state.from,
                            to: this.store.state.to,                           
                        });
                    }

                    break;
                case 6:
                    valid = await this.validate(['carrierInfo', 'differentAddressInfo', 'importInformation'],  {
                        carrierInfo: this.store.state.carrierInfo,
                        selectedShippingOption:{
                            estimatedPickup: this.store.state.selectedShippingOption.estimatedPickup,
                        },
                        from: {
                            country: this.store.state.from.country,
                            postCode: this.store.state.from.postCode,
                        },
                        importInformation: this.store.state.importInformation,
                    });
                    break;
                case 7:
                    valid = await this.validate(['differentPaymentInformation', 'majorPaymentType'],  {
                        differentPaymentInformation: this.store.state.differentPaymentInformation,
                        majorPaymentType: this.store.state.majorPaymentType,
                        from: this.store.state.from,
                        to: this.store.state.to,
                    });
                    break;
            }

            if(noActualChange){
                return valid;
            }
            
            if(!valid){
                return false;
            }
        }
        
        if (valid && needsValidation) {  
            let currentStep = this.clientAdminStepFromActualStep(this.store.state.currentLevel); 
            let stepString = this.stepToString(currentStep);       
            if (!this.store.state.checkOutSteps[stepString]) {
                this.pushDataLayer(currentStep, this.store.state.selectedShippingOption);
                this.store.state.checkOutSteps[stepString] = true;
            }
        }
   
        this.store.state.currentLevel = newLevel;
        if(this.store.state.shippingTabLevel < newLevel){
            this.store.state.shippingTabLevel = newLevel;
        }
       
        let accordion_id = '';
        if(newLevel === 1){
            accordion_id = 'send-address-parent';
        } else if(newLevel === 2){              
            accordion_id = (this.store.state.selectedFormType === 'single' ? 'delivery-address-parent' : 'mass-shipments-parent');
        } else if(newLevel === 3){
            accordion_id = (this.store.state.inClientAdmin) ? 'package-block-parent' : 'packet-info-parent';
        } else if(newLevel === 4) {
            accordion_id = (this.store.state.inClientAdmin) ? 'shipping-option-block-parent' : 'carrier-parent';
        } else if(newLevel === 5){
            accordion_id = (this.store.state.inClientAdmin) ? 'packet-info-parent' : 'additional-payment-options-parent';
        } else if(newLevel === 6){
            accordion_id = 'carrier-parent';
        } else if(newLevel === 7){
            accordion_id = 'additional-payment-options-parent';
            if (this.store.state.inClientAdmin) {
                switch(this.store.state.differentPaymentInformation.importPayer) {
                    case "receiver":
                        this.store.state.differentPaymentInformation.importPayerCode = this.store.state.to.ups_account_number;
                        break;
                    case "sender":
                        this.store.state.differentPaymentInformation.importPayerCode = this.store.state.$siteSettings['client_number'];
                        break;
                    default:
                        this.store.state.differentPaymentInformation.importPayerCode = '';
                }
            }
        }
    
        this.openedAccordionById(accordion_id, scrollToOffset);

        if ([4,6].includes(this.store.state.currentLevel) && this.store.state.loggedInUser) {
            await this.checkClientOrdersPickup();
        }
        
        return valid;
    },
    checkClientOrdersPickup: async function(){
        let thisFunction = this;
        let url =  this.store.state.$routes['api.check_already_created_orders'];

        let postCode = thisFunction.store.state.from.postCode;
            if(thisFunction.store.state.carrierInfo.differentAddress){
                postCode = thisFunction.store.state.carrierInfo.differentAddressInfo.postCode;
            }

        await axios.post(url, {postCode:postCode}, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(response) {
            thisFunction.store.state.courierAlreadyCalled = true;
            thisFunction.store.state.carrierInfo.callCarrier = 2;
            thisFunction.store.state.carrierInfo.carrierDate = response.data.pickup_date;
            thisFunction.store.state.carrierInfo.carrierTimeFrom = response.data.pickup_time_from;
            thisFunction.store.state.carrierInfo.carrierTimeTo = response.data.pickup_time_to;
            thisFunction.store.state.carrierInfo.multiPickUpAddresses = response.data.multi_pick_up_addresses;
            thisFunction.store.state.carrierInfo.pickupAddress = response.data.pickup_address;
            thisFunction.store.state.carrierInfo.pickUpAddresses = response.data.pickup_addresses;
            
        }).catch(function(error) {     
            thisFunction.store.state.courierAlreadyCalled = false;     
            thisFunction.store.state.carrierInfo.callCarrier = 1;     
        });
    },
    getLevelIdByAccordion: function(accordionId){  
        let accordionMap = {
            'send-address-parent': 1,
            'delivery-address-parent': 2,
            'mass-shipments-parent': 2,
            'carrier-parent': 6,
            'additional-payment-options-parent': 6,
        };

        let additionalData = {
            'packet-info-parent': 3,
            'carrier-parent': 4,
            'additional-payment-options-parent': 5,
        };

        if (this.store.state.inClientAdmin) {
            additionalData = {
                'package-block-parent': 3,
                'shipping-option-block-parent': 4,
                'packet-info-parent': 5,
            };
        }

        accordionMap = Object.assign({}, accordionMap, additionalData);

        return accordionMap[accordionId];
    },
    clientAdminStepFromActualStep: function(step){
        let stepMap = {
            1: 3,
            2: 4,
            3: this.store.state.inClientAdmin ? 1 : 5,
            4: this.store.state.inClientAdmin ? 2 : 6,
            5: 5,
            6: 6,
            7: 7,
        }

        return stepMap[step];
    },
    stepToString: function(step){
        let stringMap = {
            1: 'first',
            2: 'second',
            3: 'third',
            4: 'fourth',
            5: 'fifth',
            6: 'six',
            7: 'seven',
        };

        return stringMap[step];
    },
    openedAccordionById(accordion_id, scrollToOffset=0, collapse = true){
        let other_accordions = $(`.accordion:not(#${accordion_id})`);
        let this_accordion = $(`#${accordion_id}`);

        if(this_accordion.length <= 0){
            return;
        }

        if (collapse) {
            other_accordions.find('.collapse').collapse('hide');
            other_accordions.find('.accordion-button').addClass('collapsed');
        }
        
        this_accordion.find('.collapse').collapse('show');
        this_accordion.find('.accordion-button').removeClass('collapsed');
        
        let interval = setInterval(function(){
            if($('.collapsing').length <= 0){
                $('html,body').animate({
                    scrollTop: $(`#${accordion_id}`).offset().top + scrollToOffset
                }, 500);
                clearInterval(interval);
            }
        }, 50);

        setTimeout(function(){
            clearInterval(interval);
        }, 1000);
    },
    fillAddress: function(type, addressId, isImport=false, defaultSelector = true){
        let thisFunction = this;
        let addressInfo = this.store.state.userAddresses[type][addressId];

        let computedType = type;
        if((type === 'user' && !isImport) || (type === 'receiver' && isImport)) {
            computedType = 'user';
        } else{
            computedType = 'receiver';
        }   

        if (thisFunction.store.state.inClientAdmin && !defaultSelector) {
            if((type === 'user' && isImport) || (type === 'receiver' && !isImport)) {               
                computedType = 'user';                
            } else {
               computedType = 'receiver';
            }
        }

        if(addressInfo === undefined){
            addressInfo = {
                city: '',
                username_or_company: '',
                contact_person: '',
                email: '',
                phone: '',
                address: '',
                address2: '',
                address3: '',
                country: '',
                zip_code: '',
                state: '',
                province: '',
                county: '',
                ups_account_number: '',
            };
        }

        let selectedCountry = (this.store.state.countriesList[addressInfo.country] || []).country_code || null;
        selectedCountry = selectedCountry ? selectedCountry.toLowerCase() : '';

        let addressObject = this.store.state[computedType === 'user' ? 'shipperAddressInformation' : 'deliveryAddressInformation'];

        addressObject.city = addressInfo.city;
        addressObject.companyOrSender = addressInfo.username_or_company;
        addressObject.contactPerson = addressInfo.contact_person;
        addressObject.email = addressInfo.email;
        addressObject.phone = addressInfo.phone;
        addressObject.address1 = addressInfo.address;
        addressObject.address2 = addressInfo.address2 || '';
        addressObject.address3 = addressInfo.address3 || '';

        if(computedType === 'user') {
            this.store.state.shipperFillingAddress = true;
            this.store.state.shipperAddressInformation.saveLikeNewAddress = false;
            this.store.state.from.countryId = addressInfo.country;
            this.store.state.from.country = selectedCountry;
            this.store.state.from.postCode = addressInfo.zip_code;
            this.store.state.awaitingActions.reselectCountries.from = true;
            this.store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation = true;
        } else{
            this.store.state.deliveryFillingAddress = true;
            this.store.state.deliveryAddressInformation.saveLikeNewAddress = false;
            this.store.state.to.countryId = addressInfo.country;
            this.store.state.to.country = selectedCountry;
            this.store.state.to.postCode = addressInfo.zip_code;
            this.store.state.to.ups_account_number = addressInfo.ups_account_number;
            this.store.state.awaitingActions.reselectCountries.to = true;
            this.store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = true;
        }


        let mappedItem = '';
        if(selectedCountry === 'us'){
            mappedItem = this.store.state.$siteSettings.name_maps.states[addressInfo.state];
        } else if(selectedCountry === 'ca'){
            mappedItem = this.store.state.$siteSettings.name_maps.provinces[addressInfo.province];
        } else if(selectedCountry === 'ie'){
            mappedItem = this.store.state.$siteSettings.name_maps.counties[addressInfo.county];
        } else if(selectedCountry === 'au'){
            mappedItem = this.store.state.$siteSettings.name_maps.au_states[addressInfo.state];
        }
        addressObject.stateOrProvince = mappedItem ? mappedItem.toLowerCase() : '';
        

        this.store.state[computedType === 'user' ? 'shipperAddressInformation' : 'deliveryAddressInformation'] = addressObject;

        thisFunction.store.state.shipperFillingAddress = true;

        setTimeout(function() {
            thisFunction.store.state[computedType === 'user' ? 'shipperFillingAddress' : 'deliveryFillingAddress'] = false;
        }, 100);
    },
    getMaltaCity: function(postCode) {

        if (typeof postCode === undefined) {
            return '';
        }

        let map = {
            'ATD': 'Attard',
            'BBG': 'Birzebbuga',
            'BKR': 'Birkirkara',
            'BML': 'Bormla',
            'BRG': 'Birgu',
            'BZN': 'Balzan',
            'DGL': 'Dingli',
            'FGR': 'Fgura',
            'FNT': 'Fontana',
            'FRN': 'Floriana',
            'GDJ': 'Gudja',
            'GHR': 'Gharghur',
            'GRB': 'Gharb',
            'GSM': 'Ghajnsielem',
            'GSR': 'Ghasri',
            'GXQ': 'Ghazaq',
            'GZR': 'Gzira',
            'HMR': 'Hamrun',
            'IKL': 'Iklin',
            'ISL': 'Isla',
            'KCM': 'Kercem',
            'KKP': 'Kirkop',
            'KKR': 'Kalkara',
            'KMN': 'Kemmuna',
            'LJA': 'Lija',
            'LQA': 'Luqa',
            'MDN': 'Mdina',
            'MFN': 'Marsalforn',
            'MGR': 'Mgarr',
            'MLH': 'Mellieha',
            'MQB': 'Mqabba',
            'MRS': 'Marsa',
            'MSD': 'Msida',
            'MSK': 'Marsaskala',
            'MST': 'Mosta',
            'MTF': 'Mtarfa',
            'MTP': 'Maltapost',
            'MXK': 'Marsaxlokk',
            'MXR': 'Munxar',
            'NDR': 'Nadur',
            'NXR': 'Naxxar',
            'PBK': 'Pembroke',
            'PLA': 'Paola',
            'PTA': 'Pieta',
            'QLA': 'Qala',
            'QRD': 'Qrendi',
            'QRM': 'Qormi',
            'RBT': 'Rabat',
            'SCM': 'Smartcity Malta',
            'SFI': 'Safi',
            'SGN': 'Kappara',
            'SGW': 'Siggiewi',
            'SLC': 'Santa Lucija',
            'SLM': 'Sliema',
            'TP:': 'Tigne Point',
            'SLZ': 'San Lawrenz', 
            'SNT': 'Sannat',
            'SPB': 'Qawra',
            'STJ': 'St Julians',
            'SPK': 'Spinola Park',
            'SVR': 'Santa Venera',
            'SWQ': 'Swieqi',
            'TXN': 'Tarxien',
            'VCT': 'Victoria',
            'VLT': 'Valletta',
            'XBX': 'Ta Xbiex',
            'XJR': 'Xghajra',
            'XLN': 'Xlendi',
            'XRA': 'Xaghra',
            'XWK': 'Xewkija',
            'ZBB': 'Zebbug',
            'ZBG': 'Zebbug',
            'ZBR': 'Zabbar',
            'ZRQ': 'Zurrieq',
            'ZTN': 'Zejtun',
        };
        
        let lowerPostCode = postCode.toLowerCase();
        let city = '';
        $.each(map, function(index, element){
            if(lowerPostCode.indexOf(index.toLowerCase()) !== -1){
                city = element;
            }
        });
        
        return city;
    },
    getMoroccoPostCode: function (city){
        let map = {
            'AGADIR': '80000',
            'AL HOCEIMA': '32000',
            'AZILAL': '22000',
            'BENI MELLAL': '23000',
            'BENSLIMANE': '13000',
            'BOUJDOUR': '71000',
            'BOULEMANE': '33000',
            'CASABLANCA': '20000',
            'CHEFCHAOUN': '91000',
            'CHICHAOUA': '41000',
            'DAKHLA': '73000',
            'EL JADIDA': '24000',
            'ERRACHIDIA': '52000',
            'ESSAOUIRRA': '44000',
            'FES': '30000',
            'FIGUIG': '61000',
            'GUELMIM': '81000',
            'IFRANE': '53000',
            'AL KELAA DES SRAGHNA': '43000',
            'KENITRA': '14000',
            'KHEMISSET': '15000',
            'KHENIFRA': '54000',
            'KHOURIBGA': '25000',
            'LAAYOUNE': '70000',
            'LARACHE': '92000',
            'MARRAKECH': '40000',
            'MEKNESS': '50000',
            'MOHAMMEDIA': '28800',
            'NADOR': '62000',
            'OUARZAZATE': '45000',
            'OUJDA': '60000',
            'RABAT': '10000',
            'SAFI': '46000',
            'SALE': '11000',
            'SETTAT': '26000',
            'SEFROU': '31000',
            'SIDI KACEM': '16000',
            'ES SEMARA': '72000',
            'TANGER': '90000',
            'TOUANATE': '34000',
            'TAZA': '35000',
            'TAN TAN': '82000',
            'TAROUDANT': '83000',
            'TATA': '84000',
            'TEMARA': '12000',
            'TETOUAN': '93000',
            'TIZNIT': '85000'
        };

        let lowerCity = city.toLowerCase();
        let postCode = '';
        $.each(map, function(index, element){
            if(lowerCity.indexOf(index.toLowerCase()) !== -1){
                postCode = element;
            }
        });
        
        return postCode;
    },
    getCanadaProvinceByPostCode: function(postCode, deliveryStateOrProvince){
        if (typeof postCode === undefined) {
            return '';
        }

        let thisFunction = this;       

        let map = {
            'AB': 'T',
            'BC': 'V',
            'MB': 'R',
            'NB': 'E',
            'NL': 'A',
            'NT': 'X',
            'NS': 'B',
            'NU': 'X',
            'ON': ['K', 'L', 'M', 'N', 'P'],
            'PE': 'C',
            'QC': ['G', 'H', 'J'],
            'SK': 'S',
            'YT': 'Y',
        };

        let firstLetter = postCode.trim().charAt(0).toUpperCase();

        let provinces = [];
        let allProvinces = [];

        for (let province in map) {
            let codes = map[province];
            allProvinces.push(province.toLowerCase());
            if (Array.isArray(codes)) {
                if (codes.includes(firstLetter)) {
                    provinces.push(province.toLowerCase());
                }
            } else if (codes === firstLetter) {
                provinces.push(province.toLowerCase());
            }
        }

        $(deliveryStateOrProvince.$el).find('.select2-vue-component').prop('disabled', false);

        if (provinces.length > 1) {
            thisFunction.setCanadaProvinces(provinces, deliveryStateOrProvince);
        } else {
            thisFunction.setCanadaProvinces(allProvinces, deliveryStateOrProvince);  
            if (provinces.length > 0) {
                $(deliveryStateOrProvince.$el).find('.select2-vue-component').prop('disabled', true);
            }   
        }

        return provinces.shift();
    },
    setCanadaProvinces: function(provinces, deliveryStateOrProvince) {
        if (deliveryStateOrProvince == '') {
            return;
        }

        let provincesList = this.store.state.$siteSettings['Province_list'];

        let filteredProvinces = Object.values(provincesList).filter(province => 
            provinces.includes(province.code.toLowerCase())
        );

        let values = filteredProvinces.reduce((acc, element) => {
            acc[element.code.toLowerCase()] = element.lt;
            return acc;
        }, {});
    
        deliveryStateOrProvince.updateValues(values);   
    },
    getCountryCode: function(countryId){
        let countryCode = '';
        
        $.each(this.store.state.$siteSettings.Countries_list, function(index, element){
            if(countryId.toLowerCase() === index.toLowerCase()){
                countryCode = element.code;
                return false;
            }
        });

        return countryCode;
    },
    makeCreateOrderRequest: async function(requestData, shipment) {
        let thisFunction = this;            
        
        let url = this.store.state.$routes['api.get_rated_shipment_json'];

        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios.post(url, requestData, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
    
                thisFunction.store.state.massShipmentsDetailedCosts.push(response.data.detailedCosts);
                thisFunction.store.state.detailedCosts.baseCost += response.data.detailedCosts.baseCost;
                thisFunction.store.state.detailedCosts.fuelCharges += response.data.detailedCosts.fuelCharges;
                thisFunction.store.state.detailedCosts.totalCost += response.data.detailedCosts.totalCost;
                thisFunction.store.state.detailedCosts.vat += response.data.detailedCosts.vat;
                thisFunction.store.state.detailedCosts.totalCostWithVat += response.data.detailedCosts.totalCostWithVat;
    
                $.each(thisFunction.store.state.detailedCosts.otherCharges, function (index, cost) {
                    thisFunction.store.state.detailedCosts.otherCharges[index] += cost;
                });
    
                shipment.uniqueOrderNumber = response.data.uniqueOrderNumber;
    
                resolve(true);
            } catch (error) {
                if (error.response.status === 422) {
                    $.each(error.response.data.errors, function (indexInArray, valueOfElement) {
                        showToast(valueOfElement, '#c91a13', 20000);
                    });
                } else if (error.response.status === 400) {
                    if (error.response.data.PrimaryErrorCode !== undefined) {
                        showToast(error.response.data.PrimaryErrorCode.Description, '#c91a13', 20000);
                    } else {
                        let responseData = error.response.data;
                        if (responseData.response !== undefined) {
                            $.each(responseData.response.errors, function (index, value) { 
                                showToast(value.message, '#c91a13', 20000);                          
                            });
                        } else {
                            showToast(JSON.stringify(responseData), '#c91a13', 20000); 
                        }
                    }
                }
                reject(error);
            }
        });       
    },
    validateAllFieldsAndCreateOrderMassShipments: async function() {
        let thisFunction = this;          

        let data = {
            from: {
                ...thisFunction.store.state.from,
                city: thisFunction.store.state.shipperAddressInformation.city,
            },  
            massShipments: this.store.state.massShipments,   
            shipperAddressInformation: thisFunction.store.state.shipperAddressInformation,               
            otherDeliveryInformation: thisFunction.store.state.otherDeliveryInformation,
            carrierInfo: thisFunction.store.state.carrierInfo,
            selectedShippingOption: thisFunction.store.state.selectedShippingOption,    
            selectedFormType: this.store.state.selectedFormType,   
     
            differentPaymentInformation: thisFunction.store.state.differentPaymentInformation,
            majorPaymentType: thisFunction.store.state.majorPaymentType,
            additionalAddressInfo: thisFunction.store.state.additionalAddressInfo,
        }; 
   
        let valid = await thisFunction.validate([
                'countriesFrom', 'massShipments', 'shipperAddressInformation', 'carrierInfo', 'differentAddressInfo', 'otherDeliveryInformation', 
                'commercialInvoiceModal', 'commercialInvoice', 'packagesInsurance', 'differentPaymentInformation', 'majorPaymentType',
            ],
            data, 'continue', true
        );

        if (!valid) {
            return;
        }

        thisFunction.store.state.detailedCosts.baseCost = 0;
        thisFunction.store.state.detailedCosts.fuelCharges = 0;            
        thisFunction.store.state.detailedCosts.totalCost = 0;
        thisFunction.store.state.detailedCosts.vat = 0;
        thisFunction.store.state.detailedCosts.totalCostWithVat = 0;     
        thisFunction.store.state.massShipmentsDetailedCosts = [];

        for (const shipment of thisFunction.store.state.massShipments) {           
            let requestData = {
                from: {
                    ...thisFunction.store.state.from,
                    city: thisFunction.store.state.shipperAddressInformation.city,
                },  
                to: {                    
                    country: shipment.Country,
                    postCode: shipment.PostCode,                    
                    city: shipment.City,
                    countryName: shipment.CountryName,
                },
                shipperAddressInformation: thisFunction.store.state.shipperAddressInformation,     
                deliveryAddressInformation: {
                    companyOrSender: shipment.Company,
                    contactPerson: shipment.Contact,
                    address1: shipment.Address1,
                    address2: shipment.Address2,
                    address3: shipment.Address3,
                    city: shipment.City,
                    stateOrProvince: shipment.State,
                    phone: shipment.Phone,
                    email: shipment.Email,
                },

                packages: thisFunction.getDimensionsToMassShipments(shipment, true),
                packageType: shipment.Package === '05' ? '04' : shipment.Package,
                shippingOptionCode: shipment.ServiceCode.toString(),                  
                         
                otherDeliveryInformation: thisFunction.getOtherDeliveryInfomation(shipment),
                carrierInfo: thisFunction.store.state.carrierInfo,
                selectedShippingOption: shipment.service,
                uploadedFiles: shipment.uploadedFiles,
                selectedFormType: thisFunction.store.state.selectedFormType,   
                commercialInvoiceModal: shipment.commercialInvoiceModal,
                commercialInvoice: {
                    invoiceTotal: shipment.otherDeliveryInformation.invoiceTotal,
                    invoiceCurrency: shipment.otherDeliveryInformation.invoiceCurrency,
                },    
                differentPaymentInformation: thisFunction.store.state.differentPaymentInformation,
                majorPaymentType: thisFunction.store.state.majorPaymentType,
                importInformation: thisFunction.store.state.importInformation,
                additionalAddressInfo: thisFunction.store.state.additionalAddressInfo,
                fileLocation: shipment.fileLocation,
            };             

            await thisFunction.makeCreateOrderRequest(requestData, shipment);

            if(!empty(thisFunction.store.state.carrierInfo.callCarrier)) {                
                await thisFunction.getChangedDeliveryOptionMassShipments(shipment);
            }              

        };  

        if (!thisFunction.store.state.checkOutSteps.seven) {            
            thisFunction.pushDataLayer(7);   
            thisFunction.store.state.checkOutSteps.seven = true;
        }
        
        thisFunction.store.state.calculatorState = 'payment';

    },
    validateAllFieldsAndCreateOrder: async function() {
        let thisFunction = this;
    
        if (thisFunction.store.state.selectedFormType === 'mass') {
            await thisFunction.validateAllFieldsAndCreateOrderMassShipments();
            return;
        }

        if (thisFunction.store.state.inClientAdmin) {
            let loginStatus = await thisFunction.checkLoginSessionExpiry();

            if (!loginStatus) {
                return;
            }        
        }        

        if (!thisFunction.checkSessionExpiry()) {
            return;
        }        

        let option = thisFunction.store.state.selectedShippingOption.serviceCode || '';
        let data = {
            from: {
                ...thisFunction.store.state.from,
                city: thisFunction.store.state.shipperAddressInformation.city,
            },
            to: {
                ...thisFunction.store.state.to,
                city: thisFunction.store.state.deliveryAddressInformation.city,
            },
            packages: thisFunction.store.state.packagesDimensions,
            shippingOptionCode: option.toString(),
            packageType: thisFunction.store.state.packageType,
            shipperAddressInformation: thisFunction.store.state.shipperAddressInformation,
            deliveryAddressInformation: thisFunction.store.state.deliveryAddressInformation,
            otherDeliveryInformation: thisFunction.store.state.otherDeliveryInformation,
            carrierInfo: thisFunction.store.state.carrierInfo,
            selectedShippingOption: thisFunction.store.state.selectedShippingOption,
            uploadedFiles: thisFunction.store.state.uploadedFiles,
            commercialInvoiceModal: thisFunction.store.state.commercialInvoiceModal,
            commercialInvoice: {
                invoiceTotal: thisFunction.store.state.otherDeliveryInformation.invoiceTotal,
                invoiceCurrency: thisFunction.store.state.otherDeliveryInformation.invoiceCurrency,
            },
            differentPaymentInformation: thisFunction.store.state.differentPaymentInformation,
            majorPaymentType: thisFunction.store.state.majorPaymentType,
            importInformation: thisFunction.store.state.importInformation,
            additionalAddressInfo: thisFunction.store.state.additionalAddressInfo,
        };

        if(thisFunction.insideEu() || thisFunction.store.state.otherDeliveryInformation.isDocuments){
            delete data.differentPaymentInformation.importPayer;
            delete data.differentPaymentInformation.importPayerCode;
            delete data.differentPaymentInformation.importPayerCountry;
            delete data.differentPaymentInformation.importPayerPostCode;
        }
        
        if (thisFunction.store.state.otherDeliveryInformation.hasBatteries &&
            !data.otherDeliveryInformation.description.startsWith('Li-ion sII PI966')
        ) {
            data.otherDeliveryInformation.description = 'Li-ion sII PI966. ' + data.otherDeliveryInformation.description
        }
   
        if (thisFunction.store.state.shippingTabLevel === 2) {
            thisFunction.toggleAccordion(3, true);
            return;
        }       

        let valid = await thisFunction.validate([
                'packages', 'countriesFrom', 'countriesTo', 'shippingOptionCode', 'shipperAddressInformation', 
                'deliveryAddressInformation', 'carrierInfo', 'differentAddressInfo', 'otherDeliveryInformation', 
                'commercialInvoiceModal', 'commercialInvoice', 'packagesInsurance', 'differentPaymentInformation', 
                'majorPaymentType', 'importInformation',
            ],
            data, 'continue', true
        );            

        if (!valid) {
            return;
        }

        thisFunction.store.state.uniqueOrderNumber = undefined;

        let url = thisFunction.store.state.$routes['api.get_rated_shipment_json'];
        await axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(response) {
            thisFunction.store.state.detailedCosts = response.data.detailedCosts;
            thisFunction.store.state.uniqueOrderNumber = response.data.uniqueOrderNumber;
        }).catch(function(error) {           
            if(error.response.status == 422) {              
                $.each(error.response.data.errors, function (indexInArray, valueOfElement) { 
                    showToast(valueOfElement, '#c91a13', 20000);                     
                });
            } else if(error.response.status == 400) {         
                if (error.response.data.PrimaryErrorCode !== undefined) {
                    showToast(error.response.data.PrimaryErrorCode.Description, '#c91a13', 20000);  
                } else {
                    let responseData = error.response.data;
                    if (responseData.response !== undefined) {
                        $.each(responseData.response.errors, function (index, value) { 
                            showToast(value.message, '#c91a13', 20000);                          
                        });
                    } else {
                        showToast(JSON.stringify(responseData), '#c91a13', 20000); 
                    }
                }
            }
        });


        if(thisFunction.store.state.uniqueOrderNumber === undefined){
            return;
        }

        if(!empty(thisFunction.store.state.carrierInfo.callCarrier)){
            await thisFunction.getChangedDeliveryOption();
        }            
        
        thisFunction.store.state.calculatorState = 'payment';
    },
    insideEu: function(t){
        let euCountries = [
            'ie', 'at', 'be', 'bg', 'cz', 'dk', 'ee', 'gr', 'es', 'it', 'cy', 'gr', 'lv', 'lt', 'pl', 'lu', 'mt', 'nl',
            'nl', 'pt', 'fr', 'ro', 'sk', 'si', 'fi', 'se', 'hu', 'de', 'hr',
        ];
       
        return euCountries.includes(this.store.state.from.country) && euCountries.includes(this.store.state.to.country);        
    },
    checkNotEu: function(country) {
        let euCountries = [
            'ie', 'at', 'be', 'bg', 'cz', 'dk', 'ee', 'gr', 'es', 'it', 'cy', 'gr', 'lv', 'lt', 'pl', 'lu', 'mt', 'nl',
            'nl', 'pt', 'fr', 'ro', 'sk', 'si', 'fi', 'se', 'hu', 'de', 'hr',
        ];

        return euCountries.includes(country); 
    },
    needsCity(){
        let cityRequiredList = [
            'ie', 'ae', 'cl', 'nf', 'kw', 'iq', 'qa', 'pe', 'cr', 'ma', 'gt', 'bh', 'mu', 'sv', 'ke', 'do', 'al', 'om', 'jo', 'hn', 'zm', 'sn', 
            'mv', 'gp', 'lb', 'eg', 'ng', 'ug', 'pa', 'zw', 'pf', 'gh', 'mw', 'gi', 'na', 'bn', 'nc', 'bw', 'np', 'tt', 'mo', 'jm', 'ao', 'bl', 
            'mr', 'ni', 'cw', 'mg', 'gm', 'gf', 'sr', 've', 'ml', 'et', 'bm', 'sx', 'la', 'ht', 'mp', 'pg', 'py', 'rw', 'sl', 'cd', 'sc', 'bj', 
            'gu', 'yt', 'af', 'td', 'vg', 'vu', 'sm', 'ci', 'bf', 'ga', 'ck', 'cm', 'cv', 'ne', 'ly', 'bo', 'bq', 'bq', 'bq', 'bi', 'tc', 'bb', 
            'ag', 'gd', 'fj', 'tg', 'kh', 'mf', 'kn', 'as', 'ai', 'aw', 'bs', 'bz', 'bt', 'cf', 'dm', 'dj', 'er', 'gy', 'gn', 'gw', 'ky', 'ki', 
            'km', 'cg', 'ls', 'lr', 'ms', 'mz', 'pw', 'tl', 'sb', 'ws', 'lc', 'vc', 'sz', 'to', 'tv', 'wf', 'hk',
        ];

        return {
            from: cityRequiredList.includes(this.store.state.from.country.toLowerCase()),
            to: cityRequiredList.includes(this.store.state.to.country.toLowerCase()),
        };
    },
    getChangedDeliveryOptionMassShipments: async function(shipment) {
        let thisFunction = this;
        let url = thisFunction.store.state.$routes['api.get_shipping_options_json'];

        let data = {
            from: {
                country: thisFunction.store.state.from.country,
                postCode: thisFunction.store.state.from.postCode,
                city: thisFunction.store.state.shipperAddressInformation.city,
            },
            to: {
                country: shipment.Country,
                postCode: shipment.PostCode,
                city: shipment.City,
            },
            packageType: shipment.Package,
            packages: thisFunction.getDimensionsToMassShipments(shipment, true),
            carrierInfo: thisFunction.store.state.carrierInfo,
            serviceCode: shipment.ServiceCode,
        };
        await axios.post(url, data)
        .then(function(response){
            shipment.service = response.data;
        }).catch(function(error){
            console.error(error);
        });

    },
    getChangedDeliveryOption: async function(){
        let thisFunction = this;

        let url = thisFunction.store.state.$routes['api.get_shipping_options_json'];
        let data = {
            from: {
                country: thisFunction.store.state.from.country,
                postCode: thisFunction.store.state.from.postCode,
                city: thisFunction.store.state.shipperAddressInformation.city,
            },
            to: {
                country: thisFunction.store.state.to.country,
                postCode: thisFunction.store.state.to.postCode,
                city: thisFunction.store.state.deliveryAddressInformation.city,
            },
            packageType: thisFunction.store.state.packageType,
            packages: thisFunction.store.state.packagesDimensions,
            carrierInfo: thisFunction.store.state.carrierInfo,
            serviceCode: thisFunction.store.state.selectedShippingOption.serviceCode,
        };
        await axios.post(url, data)
        .then(function(response){
            thisFunction.store.state.selectedShippingOption = response.data;
        }).catch(function(error){
            console.error(error);
        });
    },
    isToIreland: function(){
        if(this.store.state.to.country === 'gb' && (this.store.state.to.postCode || '').toLowerCase().startsWith('bt')){
            return true;
        } 
        return false;
    },
    addFocus: function(){    
        if($(".select2-search__field")[0] !== undefined) {
            $(".select2-search__field")[0].focus();  
        }            
    },
    validatePostCode: function(postCode, country, inputId){
        $(`#${inputId}`).removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent').find('span.ups-danger-text').remove();
        if(empty(postCode) || empty(country)){
            return true;
        }

        let countryCode = (country || '').toUpperCase();
        let postCodeRules = this.store.state.$siteSettings.validation_rules[countryCode] || null;
        
        if(empty(postCodeRules)){
            return true;
        }

        // Needs to be numerical or numerical+letters
        let regex = /^[a-zA-Z0-9\s]{0,100}$/i;
        if(postCodeRules[0] == 1){
            regex = /^\d{0,100}$/i;
        }
        if(!regex.test(postCode)){
            this.showError(postCodeRules[3], $(`#${inputId}`));
            return false;
        }

        if(postCodeRules[4] === 'Exact'){
            if(String(postCode).length !== postCodeRules[5] && empty(postCodeRules[6])){
                this.showError(postCodeRules[3], $(`#${inputId}`));
                return false;
            } else if(String(postCode).length !== postCodeRules[5] && String(postCode).length !== postCodeRules[6]){
                this.showError(postCodeRules[3], $(`#${inputId}`));
                return false;
            }
        } else if(postCodeRules[4] === 'Min-Max' && (String(postCode).length < postCodeRules[5] || String(postCode).length > postCodeRules[6])){
            this.showError(postCodeRules[3], $(`#${inputId}`));
            return false;
        }

        $(`#${inputId}`).removeClass('alert-danger-ups').parent().removeClass('custom-ups-error-parent').find('span.ups-danger-text').remove();
        return true;
    },
    showError: function(errorText, element){
        element.parent().find('span.ups-danger-text').remove();
        element.addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent').append(`<span class="ups-danger-text ml-3">${errorText}</span>`);
    },
    getClientDiscounts: async function(clientId){
        let thisFunction = this;
        if (clientId === null) {
            return;
        }

        let url = thisFunction.store.state.$routes['api.get_client_discounts_json'];
        let data = {
            clientId: clientId,
            from: thisFunction.store.state.from.country,
            to: thisFunction.store.state.to.country,
            toPostCode: thisFunction.store.state.to.postCode, 
            fromPostCode: thisFunction.store.state.from.postCode, 
            dimensions: thisFunction.store.state.packagesDimensions,
            packageType: thisFunction.store.state.packageType
        };

        await axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(response){
            thisFunction.store.state.temporaryClientDiscounts = response.data;
        
        }).catch(function(error){
            if(error.response.status == 422){
                console.table(error.response.data.errors);
                alert('Formoje yra klaidų');
            }
        });
    },
    pushDataLayer: function(step, shippingOption = {}) {
        let thisFunction = this;

        let data = {
            event: `checkout_step_${step}`,              
            from: {
                country: thisFunction.store.state.from.country, 
                postCode: thisFunction.store.state.from.postCode, 
                city: thisFunction.store.state.shipperAddressInformation.city,
            },
            to: {
                country: thisFunction.store.state.to.country,
                postCode: thisFunction.store.state.to.postCode, 
                city: thisFunction.store.state.deliveryAddressInformation.city,
            }       
        };  

        let additionalData = {};

        let shipperAddressInformation = thisFunction.store.state.shipperAddressInformation;
        let parsedSenderName = thisFunction.parseFirstAndLastName(shipperAddressInformation.companyOrSender); 
          
        if (step === 1) {
            additionalData = {
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: step
                        },
                        products: thisFunction.parsePackageDimensions()          
                    }              
                },   
            };
        } else if (step === 2) {            
            additionalData = {
                selected_shipping_option: thisFunction.shippingOptionsMap(shippingOption),
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: step,
                                option: shippingOption.serviceName
                            },
                        }
                    }      
            };      
        } else if ([3, 4, 5, 6, 7].includes(step)) {
            additionalData = {
                enhanced_conversions_data: {
                    email: shipperAddressInformation.email,
                    phone_number: shipperAddressInformation.phone,
                    street: shipperAddressInformation.address1,
                    city: shipperAddressInformation.city,
                    region: thisFunction.store.state.from.countryName,
                    country: thisFunction.store.state.from.countryName,
                    postal_code: thisFunction.store.state.from.postCode,
                    first_name: parsedSenderName.firstName,
                    last_name: parsedSenderName.lastName
                },
                ecommerce: {
                    checkout: {
                        actionField: {
                            step: step,
                        },
                    }
                }
            }; 

            if (step === 6) {               
                additionalData = Object.assign({}, additionalData, {
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: step,
                                option: {
                                    courier: thisFunction.store.state.carrierInfo.callCarrier
                                }
                            },
                        }
                    }
                });
            }

            if (step === 7) {               
                additionalData = Object.assign({}, additionalData, {
                    ecommerce: {
                        checkout: {
                            actionField: {
                                step: step,
                                option: {
                                    selectedPaymentOption: thisFunction.store.state.paymentOption
                                }
                            },
                        }
                    }
                });
            }
        } 

        data = Object.assign({}, data, additionalData);
        
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
    },
    shippingOptionsMap: function(shippingOption){   
        if (shippingOption == '') {
            return '';
        }
        return {
            vat: shippingOption.vat,
            total_without_vat: shippingOption.total_without_vat.replace(',', '.'),
            serviceCode: shippingOption.serviceCode,
            serviceName: shippingOption.serviceName,
            total: shippingOption.total.replace(',', '.'),
            earliestPickupDate: shippingOption.earliestPickupDate,
            estimatedPickup: shippingOption.estimatedPickup,
            estimatedDelivery: shippingOption.estimatedDelivery,
            orderUntil: shippingOption.orderUntil,
            guaranteed: shippingOption.guaranteed,
            fuelChargePercentage: shippingOption.fuelChargePercentage,
            packageType: shippingOption.packageType,
        }
    },
    parsePackageDimensions: function() {   
        let parseDimensions = [];

        let packageType = this.store.state.packageType;
        let packages = this.store.state.packagesDimensions;

        $.each(packages, function (index, item) { 
            parseDimensions.push({
                quantity: 1,
                name: packageType,
                dimension1: String(item.weight),
                dimension2: String(item.length),
                dimension3: String(item.width),
                dimension4: String(item.height),
                dimension5: item.insurance === undefined ? false : true,
            });         
        });

        return parseDimensions;    
    },
    parseFirstAndLastName: function(name) {
        let splittedPerson = name.split(" ");
        let personName = '';

        $.each(splittedPerson, function (index, name) { 
            if (index !== 0) {            
                personName += ' ' + name;
            }
        });

        return {
            firstName: splittedPerson[0],
            lastName: personName
        };
    },
    getDimensionsToMassShipments: function(shipment, split = false) {
        let length = shipment.Length;
        let width = shipment.Width;
        let height = shipment.Height;

        if (shipment.Package !== '02') {
            length = 0.1;
            width = 0.1;
            height = 0.1;
        }   
        
        if (split) {
            let dimensions = {};
            
            for (let index = 0; index < shipment.PackagesNum; index++) {
                dimensions[index] = {
                    weight: shipment.Weight,
                    length: length,
                    width: width,
                    height: height,
                }            
            }
            return dimensions;
        }     

        return  {
            weight: shipment.Weight,
            length: length,
            width: width,
            height: height,
        };
    },
    getOtherDeliveryInfomation: function(shipment) {
        return {
            description: shipment.Description,
            directDelivery: shipment.DirectDelivery,
            insuranceDeclaredValue: shipment.Insurance,
            registrationNumber: shipment.Ref,
            requireSignature: shipment.RequireSignature,
            registrationNumberSelected: shipment.RegistrationNumberChecked,
            notifications: (shipment.AboutParcel || shipment.AboutExceptions || shipment.AboutParcelDelivery) ? true : false,
            senderAboutParcelEmail: shipment.AboutParcel,
            senderAboutExceptionsEmail: shipment.AboutExceptions,
            senderAboutParcelDeliveryEmail: shipment.AboutParcelDelivery,
            senderAboutPackagePickupEmail: this.store.state.otherDeliveryInformation.senderAboutPackagePickupEmail,
            adultSignature: this.store.state.otherDeliveryInformation.adultSignature,
            cashAmount: this.store.state.otherDeliveryInformation.cashAmount,
            cashCurrency: this.store.state.otherDeliveryInformation.cashCurrency,
            cashOnDelivery: this.store.state.otherDeliveryInformation.cashOnDelivery,
            commercialInvoiceType: shipment.otherDeliveryInformation.commercialInvoiceType,
            hasBatteries: this.store.state.otherDeliveryInformation.hasBatteries,
            invoiceCurrency: shipment.otherDeliveryInformation.invoiceCurrency,
            invoiceTotal: shipment.otherDeliveryInformation.invoiceTotal,
            isDocuments: this.store.state.otherDeliveryInformation.isDocuments,
            otherAboutExceptionsEmail: this.store.state.otherDeliveryInformation.otherAboutExceptionsEmail,
            otherAboutPackagePickupEmail: this.store.state.otherDeliveryInformation.otherAboutPackagePickupEmail,
            otherAboutParcelDeliveryEmail: this.store.state.otherDeliveryInformation.otherAboutParcelDeliveryEmail,
            otherAboutParcelEmail: this.store.state.otherDeliveryInformation.otherAboutParcelEmail,
            otherNotificationsEmail: this.store.state.otherDeliveryInformation.otherNotificationsEmail,
            packageValueDiff: this.store.state.otherDeliveryInformation.packageValueDiff,
            pvaRegistration: this.store.state.otherDeliveryInformation.pvaRegistration,
            receiverAboutExceptionsEmail: this.store.state.otherDeliveryInformation.receiverAboutExceptionsEmail,
            receiverAboutPackagePickupEmail: this.store.state.otherDeliveryInformation.receiverAboutPackagePickupEmail,
            receiverAboutParcelDeliveryEmail: this.store.state.otherDeliveryInformation.receiverAboutParcelDeliveryEmail,
            receiverAboutParcelEmail: this.store.state.otherDeliveryInformation.receiverAboutParcelEmail,
            saturdayDelivery: this.store.state.otherDeliveryInformation.saturdayDelivery,
            saveVoecOrPvaCode: this.store.state.otherDeliveryInformation.saveVoecOrPvaCode,
            voecVatRegistration: this.store.state.otherDeliveryInformation.voecVatRegistration
        };
    },
    showInfo: function(shipment) {    
        if (!shipment.show) {
            shipment.show = true;
            return
        }

        shipment.show = false;
    },   
    getGuaranteed: function(guaranteed) {
        if (guaranteed === undefined) {
            return '--';
        }

        return (guaranteed ? 'Taip' : 'Ne');
    },
    getPrice: function(price) {
        if (price === undefined) {
            return '--';
        }

        return price;
    },
    formattedEstimatedDelivery: function(service) {
        if (service.estimatedDelivery === undefined) {
            return '--';
        }

        let time = moment(service.estimatedDelivery).locale(this.store.state.$siteSettings['current_lang']);
        time = time.format(`dddd L[,<br>${this.trans('until')}] LT`);
        time = time.charAt(0).toUpperCase() + time.slice(1);
        return time.replace('23:30', this.trans('end_of_work'));
    },
    formattedEstimatedPickup: function(service) {
        if (service.estimatedPickup === undefined) {
            return '--';
        }
        let time = moment(service.estimatedPickup).locale(this.store.state.$siteSettings['current_lang']);
        return time.format(`dddd L[,<br>${this.trans('until')}] LT`);
    },
    getSessionStartTime: function () {  
        return new Date().getTime();
    },
    checkLoginSessionExpiry: async function() {
        let thisFunction = this;

        if (thisFunction.store.state.$siteSettings['debug']) {
            return true;
        }

        if (!thisFunction.store.state.checkSession) {
            return true;
        }

        if (thisFunction.store.state.loginSession15MinLeft === 0) {            
            clearInterval(thisFunction.store.state.sessionChecker);    
            return false;
        }

        let url = thisFunction.store.state.$routes['client_admin.auth.check_session_expiry_json'];

        let valid = await axios.post(url)
        .then(response => {           
            thisFunction.store.state.loginSessionTimeLeft = response.data.formatted_time_left;
            thisFunction.store.state.loginSession15MinLeft = response.data.time_left;

            return response.data.valid;
        })
        .catch(error => {
            if(error.response.status == 422){
                console.table(error.response.data);                
            }      
        });

        if (!valid) {                  
            $('#sessionExpiredModal').modal('show');
            thisFunction.createOrderDraft(); 
            thisFunction.logOutSession();
        }

        return valid;
    },
    extendSession: async function() {
        let thisFunction = this;
        let url = this.store.state.$routes['client_admin.auth.extend_session'];

        await axios.post(url, {extend:true})
        .then(response => {                      
            thisFunction.checkLoginSessionExpiry();
        })
        .catch(error => {
            if(error.response.status == 422) {
                console.table(error.response.data);                
            }      
        });
        
    },
    logOutSession: async function() {
        let thisFunction = this;
        
        let url = thisFunction.store.state.$routes['client_admin.auth.logout_ajax_json'];

        await axios.post(url, {logout:true})
        .then(response => {      
                          
        })
        .catch(error => {
            if(error.response.status == 422){
                console.table(error.response.data);                
            }      
        });
    },
    checkSessionExpiry() {
        if (!this.store.state.carrierInfo.callCarrier) {
            return true;
        }

        let sessionStartTime = this.store.state.sessionStartTime;
        let currentTime = new Date().getTime();     
        let elapsedTime = (currentTime - sessionStartTime) / (1000 * 60 * 60);  

        if (this.store.state.$siteSettings['debug']) {
            let sessionTime = new Date(sessionStartTime);
            let now = new Date(currentTime);
            console.log(sessionTime.toLocaleString());
            console.log(now.toLocaleString());
        }
        
        if (elapsedTime >= 1) {
            showToast(this.trans('You_session_has_ended'), "#c91a13", 30000);
            this.toggleAccordion(6);
            $('.carrierInfo_carrierDate_input').addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent');  
            $('.carrierInfo_carrierTimeFrom_input').addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent');  
            $('.carrierInfo_carrierTimeTo_input').addClass('alert-danger-ups').parent().addClass('custom-ups-error-parent');             
            return false;            
        } 

        return true;
    },
    setCitiesFromApi: async function(postCode, type) {
        let thisFunction = this;
        let valid = false;
        let url = thisFunction.store.state.$routes['api.get_cities_by_post_code_json'];

        let capitalizeDeliveryCity = thisFunction.capitalizeWords(thisFunction.store.state.deliveryAddressInformation.city);
        let capitalizeShipperCity = thisFunction.capitalizeWords(thisFunction.store.state.shipperAddressInformation.city);

        await axios.post(url, {
            postCode: postCode
        }, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(response) {
            if (response.data.length > 0) {
                valid = true;
            }            

            if (type === 'to') {
                thisFunction.store.state.additionalAddressInfo.to = response.data;
                thisFunction.store.state.deliveryAddressInformation.city = '';
                let deliveryCities = thisFunction.store.state.additionalAddressInfo.to;

                if (deliveryCities !== undefined && deliveryCities.length > 0) {
                    if (deliveryCities.length === 1) {
                        thisFunction.store.state.deliveryAddressInformation.city = deliveryCities[0].city;
                    }
                    thisFunction.store.state.deliveryAddressInformation.stateOrProvince = deliveryCities[0].state.toLowerCase();
                    thisFunction.store.state.awaitingActions.refreshStateOrProvince.deliveryAddressInformation = true;

                    let matchDelivery = deliveryCities.find(entry => entry.city === capitalizeDeliveryCity);

                    if (matchDelivery) {
                        thisFunction.store.state.deliveryAddressInformation.city = capitalizeDeliveryCity;
                    }
                }
            } else {  
                thisFunction.store.state.additionalAddressInfo.from = response.data;   
                thisFunction.store.state.shipperAddressInformation.city = '';
                let shipperCities = thisFunction.store.state.additionalAddressInfo.from;

                if (shipperCities !== undefined && shipperCities.length > 0) {
                    if (shipperCities.length === 1) {
                        thisFunction.store.state.shipperAddressInformation.city = shipperCities[0].city;
                    }
                    thisFunction.store.state.shipperAddressInformation.stateOrProvince = shipperCities[0].state.toLowerCase();
                    thisFunction.store.state.awaitingActions.refreshStateOrProvince.shipperAddressInformation = true;

                    let matchShipper = shipperCities.find(entry => entry.city === capitalizeShipperCity);

                    if (matchShipper) {
                        thisFunction.store.state.shipperAddressInformation.city = capitalizeShipperCity;
                    }
                }
            }
        }).catch(function(error){
            if(error.response.status == 422){
                console.table(error.response.data);                
            }
        });

        return valid;
    },
    capitalizeWords: function(sentence) {
        return sentence
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    },
    createOrderDraft: async function() {
        let thisFunction = this;

        let option = thisFunction.store.state.selectedShippingOption.serviceCode || '';
        let data = {
            from: {
                ...thisFunction.store.state.from,
                city: thisFunction.store.state.shipperAddressInformation.city,
            },
            to: {
                ...thisFunction.store.state.to,
                city: thisFunction.store.state.deliveryAddressInformation.city,
            },
            packages: thisFunction.store.state.packagesDimensions,
            shippingOptionCode: option.toString(),
            packageType: thisFunction.store.state.packageType === '05' ? '04' : thisFunction.store.state.packageType,
            shipperAddressInformation: thisFunction.store.state.shipperAddressInformation,
            deliveryAddressInformation: thisFunction.store.state.deliveryAddressInformation,
            otherDeliveryInformation: thisFunction.store.state.otherDeliveryInformation,
            carrierInfo: thisFunction.store.state.carrierInfo,
            selectedShippingOption: thisFunction.store.state.selectedShippingOption,
            uploadedFiles: thisFunction.store.state.uploadedFiles,
            commercialInvoiceModal: thisFunction.store.state.commercialInvoiceModal,
            commercialInvoice: {
                invoiceTotal: thisFunction.store.state.otherDeliveryInformation.invoiceTotal,
                invoiceCurrency: thisFunction.store.state.otherDeliveryInformation.invoiceCurrency,
            },
            currentLevel: thisFunction.store.state.currentLevel === 4 ? 3 : thisFunction.store.state.currentLevel,
            shippingTabLevel: thisFunction.store.state.shippingTabLevel,
            differentPaymentInformation: thisFunction.store.state.differentPaymentInformation,
            majorPaymentType: thisFunction.store.state.majorPaymentType,
            importInformation: thisFunction.store.state.importInformation,
            additionalAddressInfo: thisFunction.store.state.additionalAddressInfo,
        };

        let url = this.store.state.$routes['api.save_order_draft'];

        await axios.post(url, data, {
            headers: {
                'Content-Type': 'application/json',
            },
        }).then(function(response) {
            // console.log(response.data);
        }).catch(function(error) {           
            console.log(error.response);
        });
    }
}
